import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export default function privilegeListModel() {
  const fetchPrivilegeListModel = reactive({
    api: apiEndpoint.bcrm_platform + "/Privilege/List",
    method: "POST",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [{ Seq: 1, Key: "query", Value: "" }],
      Ordering: [{ Seq: 1, Key: "seq", Direction: "asc" }],
    },
  });

  const reorderPrivilegeListModel = reactive({
    api: apiEndpoint.bcrm_platform + "/Privilege/Reorder",
    method: "POST",
    payload: {
      Privilege_Id: null,
      From: null,
      To: null,
    },
  });

  const fetchPrivilegeCopy = reactive({
    api: apiEndpoint.bcrm_platform + "/Privilege/Clone",
    method: "POST",
    payload: {
      Privilege_Id: null,
      Req_Identity_Id: 1,
    },
  });

  const fetchPrivilegeDelete = reactive({
    api: apiEndpoint.bcrm_platform + "/Privilege/Delete",
    method: "POST",
    payload: {
      Privilege_Id: null,
      Req_Identity_Id: 1,
    },
  });

  return {
    fetchPrivilegeListModel,
    reorderPrivilegeListModel,
    fetchPrivilegeCopy,
    fetchPrivilegeDelete
  };
}
